import { GET_SHARE_TRIP_FAILED, GET_SHARE_TRIP_REQUESTED, GET_SHARE_TRIP_SUCCESS, GET_TRIP_FAILED, GET_TRIP_REQUESTED, GET_TRIP_SUCCESS } from "resources/actionTypes";

const initialState = {
  userTrip: [],
  loading: false,
  error: null,
};
const intialShareTripState = {
  userShareTrip: [],
  loading: false,
  error:null,
}

export function userTrip(state = initialState, action) {
  switch (action.type) {
    case GET_TRIP_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_TRIP_SUCCESS:
      return {
        ...state,
        loading: false,
        userTrip: action.userTrip,
      };
    case GET_TRIP_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
export function userShareTrip(state = intialShareTripState, action){
  switch(action.type){
    case GET_SHARE_TRIP_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_SHARE_TRIP_SUCCESS:
      return{
        ...state,
        loading: false,
        userShareTrip: action.userShareTrip,
      }
    case GET_SHARE_TRIP_FAILED:
      return{
        ...state,
        loading: false,
        error: action.message,
      }
    default:
      return state;
  }
}